import React__default from 'react';
import { SkeletonLoader } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import SummaryContainer from './SummaryContainer.js';

const SummaryLoader = ()=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React__default.createElement(SummaryContainer, null, /*#__PURE__*/ React__default.createElement(SkeletonLoader, null, /*#__PURE__*/ React__default.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "60px",
        "aria-label": getLabel('common.loadingText')
    }, /*#__PURE__*/ React__default.createElement("rect", {
        width: "200",
        height: "16px",
        rx: "4",
        fill: "currentColor"
    }), /*#__PURE__*/ React__default.createElement("rect", {
        width: "180",
        height: "16px",
        rx: "4",
        fill: "currentColor",
        y: "32"
    }))));
};
var SummaryLoader$1 = SummaryLoader;

export { SummaryLoader$1 as default };
//# sourceMappingURL=SummaryLoader.js.map
